import { useState } from "react";

import { PageContainer } from "~/components/layout/PageContainer";
import { PageHeader } from "~/components/layout/PageHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "~/components/ui/tabs";

import { MermasTab } from "./components/MermasTab";
import { SobreconsumosTab } from "./components/SobreconsumosTab";

export function MermasPage() {
  const [tab, setTab] = useState("mermas");

  return (
    <PageContainer>
      <PageHeader
        title="Ajustes de Consumo"
        description="Registro y seguimiento de mermas y sobreconsumos de materia prima y aceites."
      />

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="grid w-full grid-cols-2 sm:w-auto sm:inline-grid">
          <TabsTrigger value="mermas">Mermas</TabsTrigger>
          <TabsTrigger value="sobreconsumos">Sobreconsumos</TabsTrigger>
        </TabsList>
        <TabsContent
          value="mermas"
          className="mt-4 space-y-6 animate-in fade-in-0 slide-in-from-bottom-1 duration-300"
        >
          <MermasTab />
        </TabsContent>
        <TabsContent
          value="sobreconsumos"
          className="mt-4 space-y-6 animate-in fade-in-0 slide-in-from-bottom-1 duration-300"
        >
          <SobreconsumosTab />
        </TabsContent>
      </Tabs>
    </PageContainer>
  );
}
